export default {
  GET_METHOD: 'GET',
  PATCH_METHOD: 'PATCH',
  PUT_METHOD: 'PUT',
  POST_METHOD: 'POST',
  DELETE_METHOD: 'DELETE',
};
